<div
    class="pi-dropdown my-profile-tooltip"
    piTesting="my-profile-tooltip"
    (click)="captureClickHandler($event)"
>
    <div
        class="color-neutral-900 profile-card"
        [style.width]="isMobileMenu ? '100%' : '540px'"
        [style.overflow-y]="isMobileMenu ? 'auto' : 'hidden'"
    >
        <div
            [ngClass]="
                showTabNavigation
                    ? 'profile-container'
                    : 'profile-container-no-tabs'
            "
        >
            <div class="person-header-container">
                <div class="person-name-icon-container">
                    @if (showAvatar) {
                        <div class="person-icon-edit-container">
                            <div class="person-header-icon">
                                <avatar-profile size="large"></avatar-profile>
                            </div>
                        </div>
                    } @else {
                        @if (showMe) {
                            <div class="person-header-icon">
                                <abstract-icon
                                    [iconType]="
                                        self.referencePattern?.icon
                                            ?.abstractIconSVG
                                    "
                                    [iconSize]="IconSize.Big_45"
                                    class="profile-Icon"
                                >
                                </abstract-icon>
                                <div class="profile-iconName">
                                    {{ self.referencePattern?.key | translate }}
                                </div>
                            </div>
                        }
                    }
                    <div class="person-name-email-container">
                        <div
                            [ngClass]="
                                self ? 'profile-name' : 'profile-name-no-icon'
                            "
                        >
                            {{ userName }}
                        </div>
                        <div
                            [ngClass]="
                                self ? 'profile-email' : 'profile-email-no-icon'
                            "
                        >
                            {{ initData.user?.email }}
                        </div>
                    </div>
                    @if (!editable) {
                        @if (enableEditing) {
                            <tapestry-button
                                class="edit-button"
                                icon="pencil"
                                [size]="ButtonSize.Small"
                                [color]="ButtonColor.Tertiary"
                                [buttonType]="ButtonType.Rounded"
                                (buttonClicked)="toggleEditableFields()"
                            >
                            </tapestry-button>
                        }
                    } @else {
                        @if (enableEditing) {
                            <tapestry-button
                                class="edit-button"
                                icon="lock"
                                [size]="ButtonSize.Small"
                                [color]="ButtonColor.Tertiary"
                                [buttonType]="ButtonType.Rounded"
                                (buttonClicked)="toggleEditableFields()"
                            >
                            </tapestry-button>
                        }
                    }
                </div>
            </div>
            <!-- Need to change to use <ng-content> to make more generic -->
            @if (showTabNavigation) {
                <div class="profile-nav">
                    @for (tab of navTabs; track tab; let i = $index) {
                        <div
                            class="navTab"
                            (click)="navigateToTabSection(navTabs[i])"
                        >
                            <div class="navTab-text">
                                {{
                                    TR.notImplementedKey(navTabs[i]) | uppercase
                                }}
                            </div>
                            @if (highlightTab(navTabs[i])) {
                                <div class="navTab-border-gradient"></div>
                            }
                        </div>
                    }
                </div>
            }
            <!-- use ngcontent here too -->
            <div class="profile-tab">
                @if (currentTab === profileTabs.PROFILE) {
                    <my-profile-person-info
                        [self]="self"
                        [globalNavContext]="true"
                        class="my-profile-person-info-component"
                    ></my-profile-person-info>
                }
                @if (currentTab === profileTabs.AVATARSANDNAME) {
                    <my-info
                        [editable]="editable"
                        (userNameChanged)="userNameChanged($event)"
                    >
                    </my-info>
                }
            </div>
        </div>
    </div>
</div>

@if (!isMobileMenu) {
    <div class="profile-footer">
        <div
            class="profile-footer-actions"
            [class.profile-footer-actions-center]="!enableMyFiles()"
        >
            <tapestry-button
                class="logout-button"
                [color]="ButtonColor.Tertiary"
                [size]="ButtonSize.Small"
                [text]="'label.common-terms.logout' | translate"
                (buttonClicked)="logout()"
            />
            @if (enableMyFiles()) {
                <tapestry-button
                    class="my-files-button"
                    [color]="ButtonColor.Secondary"
                    [size]="ButtonSize.Small"
                    [text]="
                        'client-core.profile.view-file-downloads' | translate
                    "
                    (buttonClicked)="navigateToMyFiles()"
                />
            }
        </div>
        <div class="information-row">
            <span>{{ piVersionKey | translate }} {{ piVersion }}</span>
            <a
                class="profile-privacy-link"
                [href]="PrivacyLink"
                target="_blank"
                rel="noopener noreferrer"
                >{{ 'linklabel.privacypolicy' | translate }}
            </a>
        </div>
    </div>
}
